import { createAction, props } from '@ngrx/store';

import { AuthSession } from '../models/active-devices.model';
import { PaginationResponse } from '@shared/models/common.model';

export const loadSessions = createAction(
  '[Active Devices] Load Sessions',
  props<{ page?: number; limit?: number }>()
);

export const loadSessionsSuccess = createAction(
  '[Active Devices] Load Sessions Success',
  props<{ sessions: AuthSession[]; pagination: PaginationResponse }>()
);

export const loadSessionsFailure = createAction(
  '[Active Devices] Load Sessions Failure',
  props<{ error: string }>()
);

export const deleteSession = createAction(
  '[Active Devices] Delete Session',
  props<{ sessionId: string }>()
);

export const deleteSessionSuccess = createAction(
  '[Active Devices] Delete Session Success'
);

export const deleteSessionFailure = createAction(
  '[Active Devices] Delete Session Failure',
  props<{ error: string }>()
);

export const terminateOtherSessions = createAction(
  '[Active Devices] Terminate Other Sessions'
);

export const terminateOtherSessionsSuccess = createAction(
  '[Active Devices] Terminate Other Sessions Success'
);

export const terminateOtherSessionsFailure = createAction(
  '[Active Devices] Terminate Other Sessions Failure',
  props<{ error: string }>()
);
